import { $_app_server } from '@/_helpers'

export const settingsService = {
  //admin actions
  saveSettings,
  saveDictantFile,
  delDictantFile,
  saveDictantSertificatFile,
  delDictantSertificatFile,
  
  saveTestSertificatFile,
  delTestSertificatFile,

  //anonimus actions
  loadSettings
}

//admin actions
function saveSettings (settings) {
  return $_app_server.post('admin/settings/save',settings).then(response => response.data)
}

function saveDictantFile (dictantFile) {
  let form = new FormData()
  form.append('file',dictantFile.file)
  form.append('watchlink',dictantFile.watchLink)
  return $_app_server.post('admin/settings/savedictantfile',form).then(response => response.data)
}

function delDictantFile () {
  return $_app_server.delete('admin/settings/deldictantfile').then(response => response.data)
}

function saveDictantSertificatFile (dictantSertificatFile) {
  let form = new FormData()
  form.append('file',dictantSertificatFile.file)
  return $_app_server.post('admin/settings/savedictantsertificatfile',form).then(response => response.data)
}

function delDictantSertificatFile () {
  return $_app_server.delete('admin/settings/deldictantsertificatfile').then(response => response.data)
}

function saveTestSertificatFile (testSertificatFile) {
  let form = new FormData()
  form.append('file',testSertificatFile.file)
  return $_app_server.post('admin/settings/savetestsertificatfile',form).then(response => response.data)
}

function delTestSertificatFile () {
  return $_app_server.delete('admin/settings/deltestsertificatfile').then(response => response.data)
}

//anonimus actions
function loadSettings () {
  return $_app_server.get('settings/load').then(response => response.data)
}